import React, { useState } from "react";
import { Table, Button, Row, Select } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import type { ColumnsType } from "antd/es/table";
import { GET_CLIENTS, GET_LOCATIONS } from "./requests";
import LoadingSpinner from "../../components/loading";
import ViewDetailModal from "./viewDetail";
import { utils, writeFile } from "xlsx";
import { client } from "../../graphql/client";
import moment from "moment-timezone";
import { Container } from "./elements";

const Clients: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [location, setLocation] = useState<string | null>(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);

  const { loading, error, data } = useQuery(GET_CLIENTS, {
    variables: {
      params: { page: 1,
        pageSize: 20 },
      location: { eq: location },
    },
  });

  const { data: locationsData } = useQuery(GET_LOCATIONS, {
    variables: {
      params: { page: 1,
        pageSize: 5 },
    },
  });

  const filteredLocations = locationsData?.locations?.results.map((location) => ({
    label: location.name,
    value: location.id,
  }));


  if (error) return <div>Error: {error.message}</div>;

  const columns: ColumnsType<any> = [
    {
      title: "Nombre",
      key: "user",
      render: (record) => <p>{record.user?.firstName} {record.user?.lastName}</p>,
    },
    {
      title: "Correo Electrónico",
      key: "email",
      render: (record) => <p>{record?.user?.email}</p>,
    },
    {
      title: "Sucursal",
      key: "location",
      render: (record) => <p>{record?.selectedLocation?.name}</p>,
    },
    {
      title: "Ubicación de Sucursal",
      key: "location",
      render: (record) => <p>{record?.selectedLocation?.address?.fullName}</p>,
    },
    {
      title: "Acciones",
      key: "actions",
      render: (row) => (
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
            setSelectedClient(row)
          }}
        >
          Ver Detalle
        </Button>
      ),
    },
  ];

  const exportOrders = async () => {
    setExportLoading(true);
    try {
      const { data } = await client.query({
        query: GET_CLIENTS,
        variables: {
          params: { page: 1,
            pageSize: 1000 },
          location: { eq: location },
        },
      });

      const headers = [
        [
          "CLIENTE",
          "NOMBRE FISCAL",
          "RFC",
          "EMAIL",
          "REGIMEN FISCAL",
          "USO CFDI",
          "PAIS",
          "ESTADO",
          "CIUDAD",
          "CALLE",
          "CP",
          "COLONIA",
          "NUM. INTERIOR",
          "NUM. EXTERIOR",
        ],
      ];

      const parcelsArr = data?.clients?.results?.map((client) => {
        const fiscal = client?.fiscalData;
        const address = fiscal?.address;

        return {
          CLIENTE: `${client?.user?.firstName ?? ""} ${client?.user?.lastName ?? ""}`,
          "NOMBRE FISCAL": fiscal?.name ?? "N/A",
          RFC: fiscal?.rfc ?? "N/A",
          EMAIL: fiscal?.email ?? "N/A",
          "REGIMEN FISCAL": fiscal?.regimenFiscal ?? "N/A",
          "USO CFDI": fiscal?.usoCFDI ?? "N/A",
          PAIS: address?.country ?? "N/A",
          ESTADO: address?.state ?? "N/A",
          CIUDAD: address?.city ?? "N/A",
          CALLE: address?.street ?? "N/A",
          CP: address?.postcode ?? "N/A",
          COLONIA: address?.colony ?? "N/A",
          "NUM. INTERIOR": address?.internalNumber ?? "N/A",
          "NUM. EXTERIOR": address?.exteriorNumber ?? "N/A",
        };
      });

      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headers);
      utils.sheet_add_json(ws, parcelsArr, { origin: "A2",
        skipHeader: true });
      utils.book_append_sheet(wb, ws, "Sheet1");
      const date = moment().format("lll");
      writeFile(wb, `Clientes-${date}.xlsx`);
    } catch (err) {
      console.log(err);
    }
    setExportLoading(false);
  }

  return (
    <Container style={{ overflow: "scroll" }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Select
          style={{ width: 200 }}
          placeholder="Filtrar por sucursal"
          options={filteredLocations}
          filterOption={false}
          onSelect={(value) => setLocation(value)}
          onClear={() => setLocation(null)}
          allowClear
        />
        <Button
          type="primary"
          size="large"
          loading={exportLoading}
          icon={<FileExcelOutlined />}
          onClick={exportOrders}
        >
          Exportar
        </Button>
      </Row>
      {!loading ? (
        <>
          <Table columns={columns} dataSource={data?.clients?.results} rowKey="id" />
          <ViewDetailModal visible={visible} setVisible={setVisible} client={selectedClient} />
        </>
      ) : (
        <LoadingSpinner />
      )}
    </Container>
  );
};

export default Clients;
